import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';

import Icon from '/@/components/icon';
import settings from '/@/core/settings';

import styles from './styles.module.css';

@autobind
export default class BrandDisplay extends Component {
    static propTypes = {
        brand: PropTypes.shape({
            type: PropTypes.oneOf(['corn', 'soy', 'crop_protection', 'weeds']),
            logo: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            theme: PropTypes.string.isRequired,
        }),
        withImage: PropTypes.bool,
        withTheme: PropTypes.bool,
        borderRadius: PropTypes.bool,
        onClick: PropTypes.func,
    };

    static defaultProps = {
        borderRadius: true,
    };

    render() {
        const { brand, borderRadius, onClick, children, withImage, withTheme } = this.props;
        const rootClassNames = classNames(
            styles.root,
            withTheme && styles[`theme-${brand.theme}`],
            borderRadius && styles.borderRadius,
            onClick && styles.clickable
        );

        return (
            <div className={rootClassNames} onClick={onClick}>
                <div className={styles.logo} style={{ backgroundImage: `url('${brand.logo}')` }} />
                {withImage && (
                    <div className={classNames(styles.image, styles[brand.type])}>
                        <div className={styles.brandOverlay} />
                        <div className={styles.overlay} />
                        <div className={styles.content}>
                            <Icon type={brand.type} size='sm' theme='white' container='circle' />
                            <span className={styles.crop}>{settings.enums.brandTypes[brand.type].label}</span>
                            {onClick && <i className='material-icons'>chevron_right</i>}
                        </div>
                    </div>
                )}
                {children}
            </div>
        );
    }
}
